import React from 'react';
import { connectingNetworkIcon } from './Icons';
import CachedImage from './Modules/CachedImage';

const LoadingPage = () => {
    return (
        <>
            <div className="backdrop"></div>
            <div className="rateLimitPopup">
                <CachedImage className='connectinImg' src={connectingNetworkIcon} userId="Loading" previewImage={connectingNetworkIcon} alt='' />
                <div className="ratelimit-content">
                    <div className="ratelimit-message2">
                        Working on It...
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoadingPage;
